/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '@swisslife/shared-ui/src/base/layout/css/layout';
import '../../../atoms/text/css/text';
import '../../../atoms/button/css/button';

import '../elements/card-content/css/card-content.scss';
import '../elements/card-content/css/modifier/no-padding.scss';
import '../elements/card-footer/css/card-footer.scss';
import '../elements/card-footer/css/modifier/no-padding.scss';
import '../elements/card-header/css/card-header.scss';
import '../elements/card-header/css/modifier/no-padding.scss';

import './card.scss';
import './modifier/my-profile.scss';
import './modifier/header-linklist.scss';
import './modifier/color.scss';
import './modifier/color-mood.scss';
import './modifier/hover-color-mood.scss';
